import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';

export default function DeleteDialog(props) {
    const classes = useStyles();
    return <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open}>
                <DialogContent dividers>
                    <div className={classes.dialog}>
                        <DeleteOutlineOutlinedIcon className={classes.deleteIcon}></DeleteOutlineOutlinedIcon>
                        <Typography className={classes.deleteText}>Delete this entry?</Typography>
                        <Typography className={classes.deleteTexsmall}>{props.table} with ID {props.id}</Typography>
                        <Button autoFocus variant="outlined" onClick={props.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button className={classes.deleteButton} variant="contained" onClick={() => props.handleDelete(props.id)} color="primary">
                            Delete
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'  
      },
  
      paper: {
          padding: '50px',
          margin: "50px",
          height: '70%'
      },

      dialog: {
          width: "400px",
          padding: "60px",
          height: "275px",
          justifyContent: "center",
          textAlign: "center"
      },

      deleteIcon: {
          fontSize: "100pt",
          color: "gray"
      },

      deleteText: {
          fontSize: "20pt"
      },

      deleteTexsmall: {
          fontSize: "14pt"
      },

      deleteButton: {
          backgroundColor: "#D84949 !important"
      }
});